import React from 'react';

const AuthForm = ({ title, imageSrc, children, footer }) => {
  return (
    <div className="min-h-screen bg-primary-shade1 flex items-start sm:items-center justify-center px-4 py-4 sm:py-8">
      <div className="bg-white shadow-lg rounded-lg w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 overflow-hidden">
        {/* Left side image - hidden on small screens */}
        <div className="hidden md:flex items-center justify-center p-6">
          <img
            src={imageSrc}
            alt="auth visual"
            className="max-h-96 object-contain"
          />
        </div>

        {/* Right side form */}
        <div className="p-6 sm:p-10 flex flex-col justify-center">
          <h2 className="text-2xl font-semibold text-[#FF7236] mb-6 text-center md:text-left">
            {title}
          </h2>
          {children}
          {footer && (
            <div className="mt-6 text-sm text-center text-gray-600">{footer}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
